import { Interpolation } from "@emotion/core";
import { Device, DarkTheme } from "../../design-tokens/media-queries";
import { Border } from "../../design-tokens/borders";
import { grid } from "../../design-tokens/grid";
import { Colors } from "../../design-tokens/colors";
import { Fonts } from "../../design-tokens/fonts";

const videoContainer: Interpolation = {
  position: "relative",
  paddingBottom: "56.25%",
  backgroundColor: Colors.LightGrey,
  marginBottom: grid(3),
  overflow: "hidden",

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },

  [Device.DesktopTablet]: {
    borderRadius: Border.RadiusSm,
  },

  "> iframe": {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100% !important",
    height: "100% !important",
  },
};

const heading: Interpolation = {
  fontSize: "18px",
  lineHeight: "22px",
  fontWeight: Fonts.Weight.SemiBold,
  marginBottom: grid(2),
};

const content: Interpolation = {
  fontSize: "14px",
  marginBottom: grid(3),

  [Device.DesktopTablet]: {
    marginBottom: grid(4),
  },

  "> *:last-child": {
    marginBottom: "0 !important",
  },
};

const styles = {
  videoContainer,
  heading,
  content,
};

export default styles;
